import React from 'react';

// UI
import Loader from '@sift/skipper/components/Loader';
import ErrorView from './ErrorView';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    position: 'relative',
    width: '100%',
  },
  overlay: {},
};

export default withStyles(styles)(props => {
  return <Loader data-testid="loader" isErrorView={<ErrorView />} {...props} />;
});
